import React from 'react';

//Return EACH small image in the image list and passes selected value for 
//corresponding bigger image
const ImageListItem = ({ image, onImageSelect }) => {
    let ImageReturn = (image.Src1130) ? image.Src1130 : image.src1130
    return (
        <img
            onClick={() => onImageSelect(ImageReturn)}
            src={image.src150}
            className='list-image'
            alt=''
        />
    );

}

export default ImageListItem;


// WEBPACK FOOTER //
// ./src/components/image-list-item.js